import { render, staticRenderFns } from "./RegistrationReport.vue?vue&type=template&id=c7dcf4f2&scoped=true"
import script from "./RegistrationReport.vue?vue&type=script&lang=js"
export * from "./RegistrationReport.vue?vue&type=script&lang=js"
import style0 from "./RegistrationReport.vue?vue&type=style&index=0&id=c7dcf4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dcf4f2",
  null
  
)

export default component.exports